let timer;
let timeMinut = null;
const defaultTimerValue = 30;
const pageWrapper = document.querySelector('.page-wrapper');
const startDisplay = document.querySelector('#super-start-display');
const levelsCount = 5;
const variantsCount = 12;
let selectedLevel = null;
let selectedVariant = null;
let hasChance = true;


function playLevelMusic() {
    let mainSound = null;
    let paused = false;
    return function (name, stop = false, pause = false, resume = false) {

        if(mainSound && stop){
            mainSound.pause();
            mainSound.currentTime = 0;
            return;
        }
        if(mainSound && pause){
            mainSound.pause();
            paused = true;
            return;
        }
        if(mainSound && resume){
            paused = false;
            mainSound.play();
            return;
        }
        if(name ){
            if(mainSound) {
                mainSound.pause();
                mainSound.currentTime = 0;
            }

            mainSound = new Audio(`./music/${name}.mp3`);
            if (typeof mainSound.loop == 'boolean')
            {
                mainSound.loop = true;
            }
            else
            {
                mainSound.addEventListener('ended', function() {
                    this.currentTime = 0;
                    this.play();
                }, false);
            }
            if(!paused){
                mainSound.play();
            }

        }

    }

}

const musicPlayer = playLevelMusic();

document.addEventListener('readystatechange', () =>{
    if(document.readyState === 'complete'){
        console.log(document.readyState);
        resetGame()
    }

});

window.addEventListener("pageshow", function(evt){
    if(evt.persisted){
        setTimeout(function(){
            window.location.reload();
        },10);
    }
}, false);

window.addEventListener('load', function (e) {
    const pre = document.querySelector('.preloader');
    const startDisplay = document.querySelector('#super-start-display');
    pre.style.display = 'none';
   startDisplay.classList.add('current-active');
   // document.querySelector('#ended-promotion-display').classList.add('current-active');

});

// functions
function popupShow(popup) {
    popup.classList.add('popup-show');
    pageWrapper.classList.add('popup-showing');
    pageWrapper.classList.add("overflowClass");

    gtag('event', 'screen_view', {
        'app_name': '585 gold',
        'screen_name' : popup.id + '-popup'
    });
}

// popupShow(document.querySelector('#popupRunOfTime'));

function popupHide(popup) {
    popup.classList.remove('popup-show');
    pageWrapper.classList.remove('popup-showing');
    pageWrapper.classList.remove("overflowClass");
}

function randomFromOne(to) {
    return Math.round((Math.random() * (to - 1)) + 1 )
}

function playSound(name) {
    let sound = new Audio(`./music/${name}.mp3`);
    sound.play()
}





function switchActiveDisplay(current, next) {
    current.classList.remove('current-active');
    next.classList.add('current-active');
}

function resetGame() {
    const level = document.querySelector('#level');

    level.dataset.variant = "0";
    level.dataset.game = "0";

    const activeItems = level.querySelectorAll('.icon-main');
    activeItems.forEach(item => item.classList.remove('picked'))

    selectedLevel = randomFromOne(levelsCount) ;
    selectedVariant = randomFromOne(variantsCount);

    const image = level.querySelector(`.level-image`);
    image.src = `images/game${selectedLevel}/var${selectedVariant}.svg`;
    level.dataset.variant = selectedVariant;
    level.dataset.game = selectedLevel;
}

function restartGame() {
    const activeItems = level.querySelectorAll('.icon-main');
    activeItems.forEach(item => item.classList.remove('picked'))
}


function showPopupStart(nextActive, popup, time) {
    popupShow(popup);
    const btn = popup.querySelector('.btn-action');
    if(btn){
        btn.addEventListener('click', (e)=> {
            e.preventDefault();
            if(popup.id === 'popupRunOfTime'){
                clearInterval(timer);
            }
            else{
                musicPlayer(selectedLevel === 1 ? 5 : selectedLevel)
                gtag("event", "level_start", {level_name: `level ${selectedLevel} variant ${selectedVariant}`})
            }


            popupHide(popup);
            const timerBlock = nextActive.querySelector('.game-timer');
            timerStart(timerBlock, time)
        }, {once: true})
    }

}

function setTimerValuesDOM(seconds) {

    return `
            <div class=" minutes">
                  <p class="time">
                      <span>0</span><span>0</span>
                  </p>
                  <p>
                      минут
                  </p>
              </div>
              <p class="separator">
                  :
              </p>
              <div class=" seconds">
                  <p class="time">
                      ${seconds < 10 ? '<span>0</span>' + '<span>'+seconds+'</span>' : '<span>'+ seconds.toString()[0] +'</span>' + '<span>'+ seconds.toString()[1] +'</span>'}
                  </p>
                  <p>
                      секунд
                  </p>
              </div>
    `
}

function timerStart(selector, time) {
    timeMinut = time ? time : defaultTimerValue;
    const inputTimer = selector.querySelector('.time-holder');
    clearInterval(timer);

    timer = setInterval(function () {
        let seconds = timeMinut%60; // Получаем секунды
        let minutes = Math.trunc(timeMinut/60%60); // Получаем минуты
        // Условие если время закончилось то...
        if (timeMinut <= 0) {
            // Таймер удаляется
            clearInterval(timer);
            // Выводит сообщение что время закончилось
            const popupRunOfTime = document.querySelector('#popupRunOfTime');
            const currentActive = selector.closest('.game-section-holder');
            gtag("event", "level_end", {
                level_name: `level ${selectedLevel} variant ${selectedVariant}`,
                success: false
            });
            if(!hasChance){
                popupRunOfTime.classList.remove('has-chance')
            }
            hasChance = false;

            showPopupStart(currentActive, popupRunOfTime)
        } else { // Иначе
            inputTimer.innerHTML = setTimerValuesDOM(seconds);
        }
        --timeMinut; // Уменьшаем таймер
    }, 1000)
}


function gameStart(time) {

    const currentActive = document.querySelector('.current-active');
    const nextActive = document.querySelector(`#level`);

    musicPlayer(null, true);
    switchActiveDisplay(currentActive, nextActive);
    const popupStart = document.querySelector(`#level-start`);
    showPopupStart(nextActive, popupStart, time);
    openFullscreen()

}

//full screen
const elem = document.documentElement;

/* View in fullscreen */
function openFullscreen() {
    if (elem.requestFullscreen) {
        elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
    }
}



//btn close current popup
const btnClosePopup = document.querySelectorAll('.btn-close-popup');

btnClosePopup.forEach(btn => {
    btn.addEventListener('click', (e)=> {
        e.preventDefault();
        const popupParent = e.target.closest('.popupHolder');
        if(popupParent){
            popupHide(popupParent)
        }
    })
})

//btn play again

const btnPlayAgain = document.querySelectorAll('.btn-play-again');

btnPlayAgain.forEach(btn => {
    btn.addEventListener('click', (e)=> {
        e.preventDefault();
        restartGame();

        const popupParent = e.target.closest('.popupHolder');
        if(popupParent){
            popupHide(popupParent)
        }
    })
})





//btns start game
const playBtn = document.querySelectorAll('.btn-play-game');

playBtn.forEach(btn => {
    btn.addEventListener('click', e => {
        const popupParent = e.target.closest('.popupHolder');
        restartGame();
        if(e.target.id === 'playBtn'){
            startDisplay.classList.add('game-started');
            pageWrapper.classList.remove('game-not-started')
        }
        if(e.target.id === 'popup-btn-end'){
            musicPlayer(null, true);
            startDisplay.classList.remove('game-started');
            pageWrapper.classList.add('end-game');
            switchActiveDisplay(document.querySelector('.current-active'), document.querySelector('#super-end-display'));
            popupHide(popupParent);
            musicPlayer('main');
            return;
        }
        if(popupParent){
            popupHide(popupParent)
        }
        gameStart()
    })
});


//btn music off

const btnsMusicOff = document.querySelectorAll('.btn-volume');

btnsMusicOff.forEach(btn => {
    btn.addEventListener('click', (e)=> {
        e.preventDefault();
        if(e.target.classList.contains('btn-volume_disabled')){
            musicPlayer(null, false, false, true);
            e.target.classList.remove('btn-volume_disabled')
        }
        else{
            musicPlayer(null, false, true);
            e.target.classList.add('btn-volume_disabled')
        }

    })
})




//items pick
const activeItems = document.querySelectorAll('.icon-main');

activeItems.forEach(item => {
    item.addEventListener('click', e => {

        const target = e.target;
        const currentActive = target.closest('.game-section-holder');

        target.classList.add('picked');


        const activeItemsCount = currentActive.querySelectorAll('.icon-main').length;
        const pickedCount = currentActive.querySelectorAll('.picked').length;

        if(activeItemsCount <= pickedCount){

            gtag("event", "post_score", {
                score: timeMinut,
                level: `level ${selectedLevel} variant ${selectedVariant}`
            });

            gtag("event", "level_end", {
                level_name: `level ${selectedLevel} variant ${selectedVariant}`,
                success: true
            });

            const popupFinish = document.querySelector(`#level-finish`);
            clearInterval(timer);
            setTimeout(()=>  popupShow(popupFinish), 200)

        }
    })
});

function declOfNum(number) {
    const words = ['секунда', 'секунды', 'секунд'];
    return words[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? Math.abs(number) % 10 : 5]];
}



function setSharingLinks(){
    const [ok, vk, tg, wa] = document.querySelectorAll('#sharing-list li a');
    const time = defaultTimerValue - timeMinut;
    const fullTime = time + ' ' + declOfNum(time);
    vk.href = `http://vk.com/share.php?url=https://zoloto585.ru/new-year-2023-rabbit-game/&comment=Все чудесатее и чудесатее... Мой результат — ${fullTime}. Попробуешь меня обыграть? Следуй за кроликом!`
    tg.href = `https://telegram.me/share/url?url=https://zoloto585.ru/new-year-2023-rabbit-game/&text=Все чудесатее и чудесатее... Мой результат — ${fullTime}. Попробуешь меня обыграть? Следуй за кроликом!!`
    wa.href = `https://wa.me/?text=Все чудесатее и чудесатее... Мой результат — ${fullTime}. Попробуешь меня обыграть? Следуй за кроликом! Ссылка: https://zoloto585.ru/new-year-2023-rabbit-game/`
    ok.href = `https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=https://zoloto585.ru/new-year-2023-rabbit-game/`

}


Pristine.addValidator("full-fio", function(value) {
    // here `this` refers to the respective input element
    return value.trim().split(' ').length > 1;

}, "Введите имя и фамилию", 1, false);

// валидация финальной формы
const formLast = document.getElementById("form-info");
const pristineten = new Pristine(formLast);

formLast.addEventListener('submit', async function (e) {
    e.preventDefault();
    pristineten.validate();
    if(!pristineten.getErrors().length){
      const btn = pristineten.form.querySelector('.btn');
      btn.classList.add('loading')
        //в форме нет ошибок

        const formData = new FormData();

        const dataRaw = {};

        pristineten.fields.forEach(el => {
            dataRaw[el.input.name] = el.input.value;
        });
        const fullName = dataRaw.name.split(' ');
        formData.append("uuid", Cookies.get('mindboxDeviceUUID'));
        formData.append("lastName", fullName[1]);
        formData.append("firstName", fullName[0]);
        formData.append("mobilePhone", dataRaw.tel.replace(/\D/gm, ''));
        formData.append("email", dataRaw.email);

        await fetch('https://presentation.wim.agency/585/ERROR', {
            method: 'POST',
            body: formData
        })
            .then(d => d.json())
            .then(res => {
                e.target.closest('.ss-bg-section').style.display = 'none';
                if(res.firstGame){

                    setSharingLinks();
                    popupShow(document.querySelector('#form-send-success'));
                    gtag("event", "sign_up", {
                        method: "Mindbox"
                    });
                    pristineten.fields.forEach(el => el.input.value = '')
                }
                else{
                    popupShow(document.querySelector('#prize-already-earned'))
                }

            })
            .catch((e)=> {
                console.log(e);
                popupShow(document.querySelector('#form-send-fail'))
            })
            .finally(()=> {
                btn.classList.remove('loading')
            })
    }
});

// валидация телефона
const inputPhone = document.getElementById("tel");

function inputValue(){
    if(this.value.substr(0,1) === "8" || this.value.substr(0,1) === "7"){
        this.value = this.value.replace(this.value.substr(0,1), '+7 (');
    }
}

inputPhone.addEventListener('input', inputValue);

let mask = Maska.create(inputPhone, {
    mask: '+7 (###) ###-##-##'
});





//gameStart(document.querySelector('#playBtn'))


